import { render, staticRenderFns } from "./ResumoMovimentacaoListFiltroModalItem.vue?vue&type=template&id=c0bf8672"
import script from "./ResumoMovimentacaoListFiltroModalItem.vue?vue&type=script&lang=js"
export * from "./ResumoMovimentacaoListFiltroModalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports